<template>

  <v-row  style="color: white">
    <h2 class="text-center page-sub-title">
      {{ $t('forCantactZoodkomak') }}
      <br>
    </h2>

    <v-col cols="6" style="height: 500px">
      <h3>{{ $t('ertebatBaZoodkomak') }}</h3>

      <div style="direction: rtl;"><i class="fa fa-phone fa-fw"></i> {{ $t('tamas1662') }}</div>
      <div style="direction: rtl;"><i class="fa fa-envelope-o fa-fw"></i>
        <a href="mailto:info@zoodkomak.com" class="__cf_email__">info@zoodkomak.com</a>
      </div>
      <div style="width: 100%;aspect-ratio:1 ;direction: rtl;"><i class="fa fa-map-marker fa-fw"></i>
        {{ $t('zoodkomakAddress') }}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d404.87815655881377!2d51.38355530357988!3d35.725597471383836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e07e60299d66b%3A0x43fba06d0e94c578!2sHardware%20Center!5e0!3m2!1sen!2s!4v1654510685372!5m2!1sen!2s" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </v-col>
    <v-col cols="6">
      <ul style="    list-style-type: none;
">
        <li class="facebook"><a href="https://www.instagram.com/ZOODKOMAK/"><img style="width: 40px" src="/images/instagram-white.png"></a></li>
        <li class="facebook"><a href="https://www.aparat.com/zoodkomak"><img style="width: 40px" src="/images/aparat-white.png"></a></li>
      </ul>

      <a class="e-namad" referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK"><img loading="lazy" referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=303769&amp;Code=WAxrXd5NiVjyjgIB3wZK" alt="" style="cursor:pointer" id="WAxrXd5NiVjyjgIB3wZK"></a>

    </v-col>

  </v-row>

</template>
<script>
  export default {
    data() {
      return {
        version: process.env.VUE_APP_APP_VERSION,
        sms_code: '',
        new_pass: '',
        repeat_pass: '',
        error: []
      }
    },
    mounted() {

    },
    methods: {
      call() {
        window.open('tel:62948');
      },
      website() {
        window.open('zoodkomak.com');

      }

    }

  }
</script>
